import React from "react";
import {
  DefaultRouteParam,
  RouteConfig,
} from "../../../../../config/router/router.config";

export type AdminCreateRouteParam = DefaultRouteParam;

export const adminCreateRoute: RouteConfig = {
  name: "Create Admin",
  Component: React.lazy(() => import("./AdminCreate.view")),
  path: "/user/admin/create",
  isPrivate: true,
};
